<template>
  <footer id="wsc-footer" class="wsc-footer">
    <div class="wsc-footer-top"></div>
    <div class="wsc-footer-middle bg-dark text-light link-inherit">
      <div class="container">
        <div
          class="wsc-footer-content d-lg-flex justify-content-center flex-row-reverse"
        >
          <ul
            class="wsc-footer-product list-unstyled d-lg-flex justify-content-center"
          >
            <li>
              <div class="wsc-footer-segment">
                <h6 class="wsc-footer-title">dr.fone</h6>
                <ul class="wsc-footer-list list-unstyled">
                  <li>
                    <a href="https://drfone.wondershare.com/about-us.html"
                      >About dr.fone</a
                    >
                  </li>
                  <li>
                    <a href="https://drfone.wondershare.com/drfone-toolkit.html"
                      >Full toolkit</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://www.wondershare.com/company/contact-us.html?_ga=2.107928898.1934263077.1557403627-633176662.1557403627"
                      >Contact us</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class="wsc-footer-segment transition ease">
                <h6 class="wsc-footer-title">Support</h6>
                <ul class="wsc-footer-list list-unstyled">
                  <li>
                    <a href="https://drfone.wondershare.com/guide/">Guide</a>
                  </li>
                  <li>
                    <a
                      href="http://support.wondershare.com/&_ga=2.142982389.1934263077.1557403627-633176662.1557403627#/guide?id=236"
                      >FAQs</a
                    >
                  </li>
                  <li>
                    <a
                      href="http://support.wondershare.com/?_ga=2.63265263.1934263077.1557403627-633176662.1557403627#/contact"
                      >Contact Support</a
                    >
                  </li>
                  <li>
                    <a href="https://drfone.wondershare.com/how-to/">How-tos</a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="wsc-footer-action">
              <div class="wsc-footer-segment">
                <h6 class="wsc-footer-title">Follow Us</h6>
                <div class="wsc-footer-social text-primary link-inherit d-flex">
                  <a target="_blank" href="https://www.facebook.com/drfonetoolkit/">
                    <i class="icon-img icon-xxs img-facebook"></i>
                  </a>
                  <a target="_blank" href="https://twitter.com/drfone_toolkit">
                    <i class="icon-img icon-xxs img-twitter"></i>
                  </a>
                  <a target="_blank" href="https://www.youtube.com/channel/UCFCjPlxFlUdo-4-LANbwLkQ">
                    <i class="icon-img icon-xxs img-youtube"></i>
                  </a>
                  <a target="_blank" href="https://www.instagram.com/drfone_toolkit/">
                    <i class="icon-img icon-xxs img-instagram"></i>
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <div class="wsc-footer-company text-center">
            <div class="wsc-footer-logo">
              <img
                src="https://images.wondershare.com/wsc-18/assets/icon/logo/wondershare-vertical-white.svg"
                alt=""
              />
            </div>
            <div class="wsc-footer-slogon">Bring simple to life</div>
          </div>
        </div>
      </div>
    </div>
    <div class="wsc-footer-bottom bg-dark text-light link-inherit text-center">
      <div class="container">
        <div
          class="wsc-footer-copyright d-lg-flex justify-content-center flex-row-reverse"
        >
          <ul class="list-inline">
            <li class="list-inline-item wsc-footer-year">
              Copyright &copy; <span>2019</span>
              <a
                target="_blank"
                href="https://www.wondershare.com/company/company.html"
                >Wondershare</a
              >.
            </li>
            <li class="list-inline-item wsc-footer-rights">
              All rights reserved.
            </li>
            <li class="list-inline-item wsc-footer-terms">
              <a
                target="_blank"
                href="https://www.wondershare.com/company/terms_conditions.html"
                >Terms & Conditions</a
              >
            </li>
            <li class="list-inline-item wsc-footer-privacy">
              <a target="_blank" href="https://www.wondershare.com/privacy.html"
                >Privacy</a
              >
            </li>
            <li class="list-inline-item wsc-footer-license">
              <a
                target="_blank"
                href="https://www.wondershare.com/company/end-user-license-agreement.html"
                >License Agreement</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MyFooter"
};
</script>

<style scoped></style>
